import { Input, Injectable, Output, EventEmitter } from '@angular/core';
import { AmplifyService } from 'aws-amplify-angular';
import { API, STORAGE_CONFIG, BUCKETS } from 'src/app/configs';

import { GeneralService } from 'src/app/shared/services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { SnackBarService } from '../services/snackbar.service';
import { VimeoService } from 'src/app/core/services/vimeo.service';
  
enum VideoToFramesMethod {
  fps,
  totalFrames
}

  @Injectable({
      providedIn: 'root'
  })
  export class FileUpload {
  
    @Input() upload: boolean = true;
    @Input() accept: any = ['jpeg', 'jpg', 'gif', 'png', 'webp', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'mp4'];
    @Input() maxFileSize: any = 400; // mb
  
    @Input() actions: any = ['delete','undelete', 'description','drag'];
    @Input() resizes : Array<any> = ['original','extralarge','large','medium','thumb'];
  
    @Input() origin: any = '';
    @Input() ref: any = '';
  
    bucketList = BUCKETS;
    @Input() bucket: number = 1;
    @Input() level: any = 'protected';
  
    @Input() max: any = -1;
  
    @Input() replace: boolean = false;
    @Input() gallery: any = '';

    @Input() ownerId: any = null;

    @Input() applyTags: any = [];

    path: any = '';

    protected lastSort = 0;
    
    
    _files: any = [];
  
    @Input()
    set files(val: any) {
      
      if(typeof val == 'undefined')
        val = [];
      this.filesChange.emit(val);
      this.setCallback({action:'setFiles', files:val});
      this._files = val;
    }
    get files() {
      return this._files;
    }
    @Output() filesChange: EventEmitter<boolean> = new EventEmitter<boolean>();
     
    typeToResize: any = ['image/jpeg', 'image/gif', 'image/png', 'image/bmp', 'image/webp','video/mp4' ,'video/webm']; // ,'video/quicktime' [TODO] - adicionar na lista após criar novo método de arquivos
  
    resizesAttr: any = {
      original : { sufix: "", type: 'original' },
      extralarge : { width: 3840, height: 2160, sufix: "_xl", type: 'extralarge' },
      large : { width: 1980, height: 960, sufix: "_lg", type: 'large' },
      medium : { width: 1024, height: 800, sufix: "_md", type: 'medium' },
      thumb : { width: 520, height: 390, sufix: "_sm", type: 'thumb' },
      tiny : { width: 120, height: 120, sufix: "_tn", type: 'tiny' }
    };
  
    constructor(
      protected toast: SnackBarService,
      protected as: AmplifyService,
      protected http: HttpService,
      protected gs: GeneralService,
      protected vimeo : VimeoService
  ) {
        
        this.as.auth().currentCredentials().then(result => {
          this.path = result?.identityId || result?.data?.IdentityId;
        });
        this.as.storage().configure(STORAGE_CONFIG);
    }

    log(type: any, message: any, duration: number = 2000, complement: any = [], button: any = '', callback: any = false) {
      let snackBarRef: any = false;

      complement?.map(item=> message += item?.text || item);
      
      switch (type) {
        case 1:
          snackBarRef = this.toast.open(message, button, {
            duration: duration
          }); 
          break;
      }
      if (snackBarRef != false && button != '' && callback != false) {
        snackBarRef.onAction().subscribe(callback);
      }
    }

    getFilesChangeSubscription(){
      return this.gs.filesChangeSubscription$;
    }

    setCallback(data){
      this.gs.filesChangeSubscription.next(data);
    }
  
    setDefault(){
      this.upload = true;
      this.accept = ['jpeg', 'jpg', 'gif', 'png', 'webp', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'mp4'];
      this.maxFileSize = 270;
    
      this.actions = ['delete','undelete', 'description','drag'];
      this.resizes = ['original','extralarge','large','medium','thumb'];
    
      this.origin = '';
      this.ref = '';
    
      this.bucket = 1;
      this.level = 'protected';
    
      this.max = -1;
    
      this.replace = false;

      this._files = [];
    }
  
    fileIsImage(file){
      return this.typeToResize.indexOf(file.type) > -1;
    }
  
    getFile(file, type = 'large', complete = false):any{
      if(!this.fileIsImage(file))
        return this.bucketList[file.storage_bucket] + '/' + file.storage_level + '/' +  file.storage_path + '/' + (file?.filename || file?.hashName || file?.name) + '.' +file.extension;  
  
      if(typeof file['variations'] == 'undefined' || !file['variations'].length || [1,4].indexOf(file.status) == -1)
        return false;
  
      let r = file['variations'].filter(item => item['resizeType'] == type || (type == 'video' && item.type.indexOf('video') > -1)) || [];
  
      if(!r.length)
        return false;
  
      let name = r[0]?.url || (this.bucketList[file.storage_bucket] + '/' + file.storage_level + '/' +  file.storage_path + '/' + (r[0]['filename'] || r[0]['name']));

      return !complete? name : {filename : name, ...r};
    }

    getFileType(extension){
      return ({
        "webmanifest" : "application/manifest+json",
        "dwg" : "image/x-dwg",
        "dxf" : "image/x-dxf",
        "dwf" : "drawing/x-dwf",
        "skp" : "application/vnd.koan",
        "skt" : "application/vnd.koan",
        "skm" : "application/vnd.koan",
        "skd" : "application/vnd.koan",
      })[extension] || null;
    }
  
    fileEvent(fileInput: any, tag:any = false) {
      var th = this;
      //this._files = [];
      var files = fileInput?.target?.files || fileInput;
      var newFile = fileInput?.target?.files;
      var filesOut = [];
      var filesToUpload = [];

      this.lastSort = parseInt(this._files[this._files.length-1]?.sort) || files[0]?.sort || 0;
  
      for (var i = 0, len = files.length; i < len; i++) {
        var file = files[i];
        var extension = fileExtension(file.name)?.toLowerCase() || false;
        
        if(newFile){
          file.tags = [];
          if(!!this.applyTags?.length)
            file.tags = this.applyTags;
            
          if(tag && !file.tags.includes(tag))
            file.tags.push(tag);
        }

        if(!extension){
          filesOut.push({ filename: file.name, text: "Erro ao enviar o arquvio - " + file.name });
        } else if (this.max > 0 && this._files.length + 1 > this.max && !this.replace) {
          filesOut.push({ filename: file.name, text: "Quantidade excedida - " + file.name });
  
        } else if (typeof extension == 'undefined' || (this.accept != '' && this.accept.indexOf(extension) == -1)) {
          filesOut.push({ filename: file.name, text: "Arquivo não permitido - " + file.name });
  
        } else if (file.size > 1024 * 1024 * this.maxFileSize) {
          filesOut.push({ filename: file.name, text: "Arquivo maior que " + this.maxFileSize + " mb - " + file.name });
  
        } else {
          var needResize = this.typeToResize.indexOf(file.type) > -1;
          var fileName = fileHashName();
          let fileType = file?.type || this.getFileType(extension);


          let sort = this.lastSort + (filesToUpload?.length == 0? 1 : filesToUpload?.length + 1);

          file.filename = fileName + '.' + extension;

          this._files.push({
            name: file.name,
            upload: true,
            loading: 0,
            status: needResize ? -11 : -12,
            hashName: fileName,
            extension: extension,
            type: fileType,
            original: file,
            size: file.size,
            sort: sort,
            tags: file?.tags || [],
            old_file_id : file?.old_file_id,
            variations: needResize ? [] : [file]
          });
          
          filesToUpload.push({
            name: file.name,
            filename: fileName,
            extension: extension,
            type: fileType,
            origin: this.origin,
            gallery: this.gallery,
            ref: this.ref,
            tags: file?.tags || [], 
            sort: sort,
            storage_level: this.level,
            storage_path : this.path,
            storage_bucket : this.bucket
          });
        }
      }
      console.log(filesOut);
      if (!!filesOut.length)
        return this.log(1, "!Ops, alguns arquivos não foram enviados: ", 4000, filesOut);
            
      if(!filesToUpload?.length)
        return this.log(1, 'Lista de arquivos está vazia');
  
      this.http.post<any>(API.general.files.fileBeforeUpload, {ids : filesToUpload, owner_person_id : this.ownerId})
        .then(success => {
  
          if(typeof success != 'object')
            return 'Error';

          for (var i in success)
            if(success.hasOwnProperty(i)) {
              if(typeof success[i].error !=='undefined' && !filesOut.length){
                  console.log(success[i].error);
                  this.log(1, "!Ops, alguns arquivos não foram enviados: ", 4000 , [i]);
              } else {
  
                var key = th.arraySearch(th._files, 'hashName', i, true);
                if(key){
                  key.file_id = success[i].file_id;
                  th.APIafterUpload();
                }
              }
  
            }
        })
        .catch((err) => this.gs.error(err));
  
      this.imageResize();
    }
  
  
    imageResize(pos: number = 0) {
      var th = this;
  
      if (typeof this._files[pos] === 'undefined')
        return this.storagePut();
  
      var file = this._files[pos];
      
      if (th.typeToResize.indexOf(file.type) == -1 || typeof file.upload == 'undefined')
        return this.imageResize(pos + 1);
  
      if (!th.resizes.length)
        return th.log('sys', 'Define resizes of images');
  
      function loadImg (url: any, originalFileType:any = false, filesSize = 0) {

        if(!originalFileType)
          originalFileType = file.type;

        var img = document.createElement("img");
        img.src = url?.target?.result || url;
        img.onload = function (e) {
          var totalSize = filesSize;

          th.resizes.map(item => {
            let size = th.resizesAttr[item];
  
            if(!file.variations.filter(item => item.resizeType == size.resizeType)?.length){

              let extension = 'webp';
              let fileType = "image/webp";

              if(th.typeToResize.indexOf(originalFileType) > -1){

                if(originalFileType == 'image/webp'){
                  extension = 'jpeg';
                  fileType = 'image/jpeg';
                }

                var name = (typeof size.prefix !== 'undefined' ? size.prefix : "") + file.hashName + (typeof size.sufix !== 'undefined' ? size.sufix : "") + "." + extension;
                var nFile = th.makeImage(size, img, fileType, name);
    
                file.variations.push(nFile);
                totalSize += nFile.size;
              }

              extension = originalFileType.split('/')[1];//file.extension;
              fileType = originalFileType;

              var name = (typeof size.prefix !== 'undefined' ? size.prefix : "") + file.hashName + (typeof size.sufix !== 'undefined' ? size.sufix : "") + "." + extension;
              var nFile = th.makeImage(size, img, fileType, name);
  
              file.variations.push(nFile);
  
              totalSize += nFile.size;
            }
  
          });


          if(file.type.indexOf('video') > -1){
            file.variations.push({filename: file.original.filename, type: file.original.type, resizeType: null, body: file.original, width: file.variations[0].width, height: file.variations[0].height, size: file.original.size, total: file.original.size});
            totalSize += file.original.size;
          }
  
          file.size = totalSize;
          file.status = -12;
          
          th.storagePut();
          th.imageResize(pos + 1);
        }
      }

      function loadVideo(data){

        let size = file.original.size;

        th.getFrames(data?.target?.result || data, 1).then(result => {
          if(result.length > 0)
            loadImg(result[0],'image/png',size);
        })
        .catch(err => console.log(err));
      }

      if(file?.original?.base64)
          loadImg(file.original.base64);
      else {
          var reader = new FileReader();
          reader.onload = file.type.indexOf('video') > -1? loadVideo : loadImg;
          reader.readAsDataURL(file.original);            
      }
  
    }
    
    makeImage(size: any, img: any, type, name) {
  
      var nFile: any = { filename: name, type: type, resizeType: typeof size.type === 'undefined' ? null : size.type };

      if(nFile.resizeType == 'original'){
        var blob = this.urlToBlob(img.src, nFile.type);
      } else {

        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
    
        var MAX_WIDTH = size.width;
        var MAX_HEIGHT = size.height;
    
        var width = img.width;
        var height = img.height;
    
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
    
        nFile.width = canvas.width = width.toFixed(0);
        nFile.height = canvas.height = height.toFixed(0);
    
        var ctx = canvas.getContext("2d");
        ctx.imageSmoothingQuality = "high";
        ctx.imageSmoothingEnabled = true;
        ctx.drawImage(img, 0, 0, width, height);
    
        var dataurl = canvas.toDataURL(nFile.type);
    
        var blob = this.urlToBlob(dataurl, nFile.type);
      }
  
      nFile.body = blob;
      nFile.size = blob.size;
  
      return nFile;
  
    }
  
    urlToBlob(dataURL, type){
      var blobBin = atob(dataURL.split(',')[1]);
      var array = [];
      for(var i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], {type: type});
    }
  
    arraySearch(array, key, value, returnOject: boolean = false) {
  
      for (var k in array)
        if (array.hasOwnProperty(k)) {
          if (array[k] == value || (array[k][key] != 'undefined' && array[k][key] == value))
            return returnOject ? array[k] : k;
        }
  
      return false;
    }
  
    updateProgress(progress: any, i: number, j: number) {
      this._files[i].variations[j].loaded = progress.loaded;
      this._files[i].variations[j].total = progress.total;
      
      if(progress.loaded == progress.total){  
        //delete this._files[i].variations[j].loaded;
        delete this._files[i].variations[j].body;
        //delete this._files[i].variations[j].uploaded;
      }
  
      var loaded = 0;
      var total = 0;
      var totalUploaded = this._files[i].variations.filter(item => item?.uploaded == true)?.length || 0;
      
      for (var k = 0, len = this._files[i].variations.length; k < len; k++){
        loaded += this._files[i].variations[k]?.loaded || 0;
        total += this._files[i].variations[k]?.total || 0;
      }
          
      this._files[i].loading = (loaded * 100 / total).toFixed(0);

      if(this._files[i]?.upload)
        if (this._files[i].loading >= 100 && totalUploaded == this._files[i].variations.length) {
          this._files[i].status = 2;
          
          this.APIafterUpload();
          delete this._files[i].upload;
        } else {
          this.storagePut();
        }
  
    }
  
    APIafterUpload() {
      var th = this;
      
      let len = this._files?.length;
      Object.entries(this._files).forEach(([k, v]: any) => {
      //for (var k = 0, len = th._files.length; k < len; k++){
      
        if(typeof this._files[k].file_id != 'undefined' && this._files[k].status == 2){

          let variations = this._files[k].variations.map(item => {
            if(item instanceof File){
              item = {
                filename : item['filename'],
                size : item.size,
                type : item.type
              };
            } else {
              delete item?.body;
              delete item?.uploaded;
              delete item?.loaded;
              delete item?.total;
            }
            return item;
          });

          let fileHttp:any = { file_id: this._files[k].file_id, variations: variations, owner_person_id : this.ownerId };
          
          this._files[k].status = 3;
          
          if(this.replace){
            if(len > 1)
              fileHttp['old_file_id'] = this._files[k]?.old_file_id || this._files[len-2].file_id;
            else if(this._files[k]?.old_file_id)
              fileHttp['old_file_id'] = this._files[k]?.old_file_id;
          }
  
          this.http.put<any>(API.general.files.fileAfterUpload, fileHttp)
            .then(success => {
              
              var file = this.arraySearch(this._files, 'file_id', fileHttp.file_id, true);
              file.status = 1;
              this.files = this._files.filter(item => !fileHttp?.old_file_id || fileHttp.old_file_id != item.file_id);
              this.setCallback({action:'sendFiles', files:this.files});
            })
            .catch((err) => this.gs.error(err));       
        }
      });
    }
          
    getFilesToSort(without = []){
      var sort = [];
      for (var k = 0, len = this._files.length; k < len; k++) {
        if(without.indexOf(this._files[k].file_id) == -1)
          sort.push(this._files[k].file_id);
      }
      return sort;
    }

    APIupdateSort() {
      var sort = this.getFilesToSort();
  
      this.http.put<any>(API.general.files.fileUpdateSort, {ids : sort, owner_person_id : this.ownerId})
        .then(result => {
          this.updateSort(sort);
          this.setCallback({action:'sort', files: this.files})
        })
        .catch((err) => this.gs.error(err));
    }
  
    APIupdateTag(file) {
  
      this.http.put<any>(API.general.files.fileUpdateTag, { file_id: file.file_id, tags: file.tags, owner_person_id : this.ownerId})
        .then(success => {
          this.setCallback({action:'tags', files: this.files});
          delete file.tagUpdated;
        })
        .catch((err) => this.gs.error(err));
  
    }
  
    APIdelete(list) {

      var sort = this.getFilesToSort(list);

      this.http.del<any>(API.general.files.fileDelete, {ids : list, sort: sort, gallery: this.gallery, owner_person_id : this.ownerId})
        .then(success => {
            setTimeout(() => { 
              this.files = this._files = this._files.filter(item => item.status == 1); 
              this.updateSort(sort);
              this.setCallback({action:'delete', files: this.files}); 
            }, this.actions.indexOf('undelete') > -1? 3600 : 0);
        })
        .catch((err) => this.gs.error(err));
  
    }
  
    APIundelete(list) {

      var sort = this.getFilesToSort();
  
      this.http.del<any>(API.general.files.fileUndelete, {ids : list, sort: sort, gallery: this.gallery, owner_person_id : this.ownerId})
        .then(result => {
          this.updateSort(sort);
          this.setCallback({action:'undelete', files: this.files});
        })
        .catch((err) => this.gs.error(err));
  
    }
  
    APIdescription(file){
      
      this.http.put<any>(API.general.files.fileDescription, {"description": file.description, "file_id":file.file_id, owner_person_id : this.ownerId})
        .then(result => {
          this.updateDescription(file);
          this.setCallback({action:'description', files: this.files});
        })
        .catch((err) => this.gs.error(err));
    }

    updateDescription(list){
      this.files = this._files.map(item => {
        if(item.filed_id == list.file_id)
          item.description = list.description;
        
        return item;
      });
    }

    updateSort(list){
      this.files = this._files.map(item => {
        const k = list.indexOf(item.file_id);
        if(k > -1)
          item.sort = k+1;
        return item;
      });
    }
  
    updateImage(result, i, j) {
      this._files[i].variations[j].uploaded = true;
      this.storagePut();
    }
  
   async storagePut() {
      var th = this;
  
      for (var i = 0, len = this._files.length; i < len; i++) {
        var filePoller = this._files[i];
  
        if (filePoller && [-12, -13].indexOf(filePoller.status) > -1) {
  
          filePoller.status = -13;
          filePoller.storage_level = th.level;
          filePoller.storage_bucket = th.bucket;
          filePoller.storage_path = th.path;
  
          for (var j = 0, len = filePoller.variations.length; j < len; j++) {
            var file = filePoller.variations[j];
  
            if (typeof file.uploaded === 'undefined') {
              this._files[i].variations[j].uploaded = true;

              /*if(file.type.indexOf('video') > -1 && typeof th._files[i].variations[j].url == 'undefined'){
                return await this.vimeo.start([file?.body || file], {
                  progressCallback : (progress) => {
                    //th.updateProgress(progress, i, j);  
                  },
                  urlCallback : (result) => {
                    th._files[i].variations[j].url=result.body.link;
                  },
                  successCallback : (r) => {
                    //th._files[i].variations[j].url=r.path;
                    //th.updateProgress({loaded:100, total:100}, i, j);
                    delete th._files[i].variations[j].uploaded;
                    th.storagePut();
                  }
                });
              }*/
              
              return await this.as.storage().put(file.filename, file?.body || file, {
                level: th.level,
                contentType: file.type,
                cacheControl : 'max-age=315360000',
                metadata: { 
                  source: 'centralcorretor.com.br'
                },
                progressCallback: (progress) => {
                  th.updateProgress(progress, i, j);
                }
              }
              ).then(result => { 
                  this.storagePut();
              }) // {key: "test.txt"}//this.updateImage(result, i, j)
              .catch((err) => this.gs.error(err));
            }
          }
        }
      }
  
    }


    getFrames(videoUrl: any, amount: number, type: VideoToFramesMethod = VideoToFramesMethod.fps): Promise<any> {
      
      return new Promise((resolve: (frames: any) => void, reject: (error: string) => void) => {
        let frames: any = [];
        let canvas: HTMLCanvasElement = document.createElement('canvas');
        let context: CanvasRenderingContext2D = canvas.getContext('2d');
        let duration: number;
  
        let video = document.createElement('video');
        video.preload = 'auto';
        let that = this;
        video.addEventListener('loadeddata', async function() {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          duration = video.duration;
  
          let totalFrames: number = amount;
          if (type === VideoToFramesMethod.fps) {
            totalFrames = duration * amount;
          }
          //for (let time = 0; time < duration; time += duration / totalFrames) {
            frames.push(await that.getVideoFrame(video, context, amount));
          //}
          resolve(frames);
        });
        video.src = videoUrl;
        video.load();
      });
    }
  
    private getVideoFrame(video: HTMLVideoElement, context: CanvasRenderingContext2D, time: number): Promise<any> {
      return new Promise((resolve: (frame: any) => void, reject: (error: string) => void) => {
        let eventCallback = () => {
          video.removeEventListener('seeked', eventCallback);
          this.storeFrame(video, context, resolve);
        };
        video.addEventListener('seeked', eventCallback);
        video.currentTime = time;
      });
    }
  
    private storeFrame(video: HTMLVideoElement, context: CanvasRenderingContext2D, resolve: (frame: any) => void) {
      //context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

      var canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      var ctx = canvas.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  
      var dataurl = canvas.toDataURL('image/png');
  
      var blob = dataurl;

      resolve(blob);
    }
  
  
  }
  
  
  function fileExtension(filename) {
    var re = /(?:\.([^.]+))?$/;
    return re.exec(filename)[1];
  }
  function fileHashName() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }